import SubmitRealplay from '../Components/SubmitRealPlay/SubmitRealplay';
const RealPlaySubmit = () => {
  return <SubmitRealplay />;
};

export default RealPlaySubmit;
